import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PickupAtTheStoreColumn from "../../../components/bigbox/PickupAtTheStoreColumn";
import { CheckBoxInput, SelectForm } from "../../../components/common/Buttons";
import ContentValidation from "../../../components/common/ContentValidation";
import RegularOrderChildren from "../../../components/common/GlobalModals/Orders/RegularOrderChildren";
import RangePickerComp from "../../../components/common/RangePickerComp";
import TableFilterBox from "../../../components/common/TableFilterBox";
import PaginationComp from "../../../components/Dashboard/items/Pagination";
import Container from "../../../components/Layout/Container";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import InputText from "../../../components/orders/accepted_orders/InputFilter";
import { handleKeyDown } from "../../../helpers/FunctionsGlobal";
import {
  exportDocument,
  formatDatePlus,
  getDateFormat,
} from "../../../helpers/Utils";
import useFetch from "../../../hooks/useFetch";
import { getOrder } from "../../../redux/Actions/orderAction";
import { createConsumer } from "@rails/actioncable";
import { Select } from "antd";
import { Label } from "../../../components/globals";
const { Option, OptGroup } = Select;

const initialFilters = {
  order_id: "",
  status: "active",
  date: ["", ""],
  goods: "",
  supplier: undefined,
};
export default function PickupAtTheStoreScreen({ match }) {
  const dispatch = useDispatch();
  const modalRef = React.createRef();

  const [requiredOrderId, setRequiredOrderId] = useState(0);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(50);
  const [selected, setSelected] = useState([]);
  const [filterString, setFilterString] = useState(
    "&q[status_in][]=unprepared&q[status_in][]=ready"
  );
  const [filters, setFilters] = useState(initialFilters);
  const { value, loading, setValue } = useFetch(
    `/api/v1/pickups?page=${page}&per_page=${pageCount}${filterString}`,
    {},
    [page, pageCount, filterString]
  );

  useEffect(() => {
    // WebSockets
    const consumer = createConsumer();
    consumer.subscriptions.create(
      { channel: "PickupChannel" },
      {
        connected() {
          console.log("Connected PickupChannel WS!");
        },
        received(data) {
          console.log({ data });
          if (data.type == "order_document") {
            setValue((prev) => {
              if (!prev?.data) return prev;
              return {
                ...prev,
                data: prev.data.map((d) => {
                  if (data.data.order_id == d.shipment.order.id) {
                    let obj = { ...d };
                    obj.shipment.order.order_documents.push(data.data);
                    return obj;
                  }
                  return d;
                }),
              };
            });
            return;
          }
          if (data.type == "deleted_order_shipment") {
            setValue((prev) => {
              if (!prev?.data) return prev;
              return {
                ...prev,
                data: prev.data.map((d) =>
                  d.shipment_id == data.data.id ? { ...d, ...data.data } : d
                ),
              };
            });
            return;
          }
          if (data.type == "status") {
            console.log({ data });
            return setValue((prev) => {
              if (!prev?.data) return prev;
              return {
                ...prev,
                data: prev.data.map((d) => {
                  if (data.pickup_ids.includes(d.id)) {
                    return {
                      ...d,
                      status: data.status,
                      updated_at: new Date().toISOString(),
                    };
                  }
                  return d;
                }),
              };
            });
          }
        },
      }
    );
    // WebSockets end
  }, []);

  useEffect(() => {
    onFilter();
  }, [filters.supplier, filters.date, filters.status]);

  const onChangeFilters = (e) => {
    const { value, name } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onFilter = () => {
    console.log("onFilter()");
    let filter_string = "";

    const { order_id, status, date, goods, supplier } = filters;
    if (status) {
      if (["active", "inactive"].includes(status)) {
        if (status == "active")
          filter_string += `&q[status_in][]=unprepared&q[status_in][]=ready`;
        else filter_string += `&q[status_in][]=given_away`;
      } else {
        filter_string += `&q[status_eq]=${status}`;
      }
    }
    if (order_id)
      filter_string += `&q[shipment_orders_id_order_cont]=${order_id}`;
    if (goods)
      filter_string += `&q[shipment_shipment_order_rows_order_row_product_name_or_shipment_shipment_order_rows_order_row_product_reference_or_shipment_shipment_order_rows_order_row_product_upc_cont]=${goods}`;
    if (date && date[0]) {
      filter_string += `&q[updated_at_gteq]=${date[0]}`;
      if (date[1] && date[1].length > 0) {
        filter_string += `&q[updated_at_lteq]=${formatDatePlus(date[1])}`;
      }
    }

    // if (goods) filter_string += `&q[id_order_eq]=${order_id}`;
    if (supplier)
      filter_string += `&q[shipment_pickup_address_id_eq]=${supplier}`;

    setSelected([]);
    setFilterString(filter_string);
  };

  const orderModal = (order_id, id) => {
    const type = order_id.startsWith("FO") ? "FakeOrder" : "Order";
    if (type == "FakeOrder") {
      modalRef.current.openModal("FakeOrderShowModal");
      setRequiredOrderId(id);
      return;
    }
    setRequiredOrderId(order_id);
    console.log({ type });
    dispatch(getOrder(id));
    modalRef.current.openModal("OrderShowModal");
  };

  return (
    <Container
      location={{
        locationName: "Pickups",
        locationUrl: match.url,
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={value?.totals || 0}
          length={value?.data?.length || 0}
          onChangeCountPage={setPageCount}
          countPage={pageCount}
          text2="Pickups"
        />
      </ContentBlock>
      <ContentBlock containerClass="py-1">
        <FilterBlock
          page={page}
          pageCount={pageCount}
          filterString={filterString}
          filters={filters}
          onChangeFilters={onChangeFilters}
          clearFilter={() =>
            setFilters({
              ...initialFilters,
              supplier: filters.supplier == undefined ? null : undefined,
            })
          }
          onFilter={onFilter}
        />

        <div>
          <ContentValidation loader={loading} array={value?.data}>
            <div className="table-responsive">
              <table className="table table-sm table-hover mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">
                      <CheckBoxInput
                        checked={selected.length == value?.data?.length}
                        onChange={() => {
                          if (selected.length == value?.data?.length) {
                            setSelected([]);
                          } else {
                            setSelected(value?.data?.map((d) => d.id) || []);
                          }
                        }}
                      />
                    </th>
                    <th className="text-black">Order no.</th>
                    <th className="text-black">Status</th>
                    <th className="text-black">Status set at</th>
                    <th className="text-black">Client</th>
                    <th className="text-black">Goods</th>
                    <th className="text-black">Pickup at</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {value?.data?.map((item, idx) => {
                    if (item?.shipment) {
                      return (
                        <PickupAtTheStoreColumn
                          key={idx}
                          item={item}
                          orderModal={orderModal}
                          selected={selected.includes(item.id)}
                          setValue={setValue}
                          setSelected={() =>
                            setSelected((prev) => {
                              let obj = [...prev];
                              if (obj.includes(item.id)) {
                                return obj.filter((value) => value !== item.id);
                              } else {
                                return [...obj, item.id];
                              }
                            })
                          }
                        />
                      );
                    }
                    return null;
                  })}
                </tbody>
              </table>
              <PaginationComp
                setPagination={setPage}
                page={page}
                totals={value?.totals || 0}
                pageCount={pageCount}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>
      <div id="modal-roots" />
      <RegularOrderChildren ref={modalRef} requiredOrderId={requiredOrderId} />
    </Container>
  );
}

const FilterBlock = ({
  page,
  pageCount,
  filterString,
  clearFilter,
  filters,
  onChangeFilters,
  onFilter,
}) => {
  const { value: pickup_address } = useFetch("/api/v1/pickup_addresses");
  const renderCustomButton = () => {
    return (
      <>
        <button
          className="btn btn-sm float-right mr-3 btn-dark"
          onClick={() => {
            exportDocument(
              `/api/v1/pickups/pickups_download?page=${page}&per_page=${pageCount}${filterString}`,
              `pickup_report_download.xlsx`,
              "POST"
            );
          }}
        >
          Pickup report
        </button>
      </>
    );
  };
  return (
    <TableFilterBox clearFilter={clearFilter} button1={renderCustomButton()}>
      <div className="px-1">
        <InputText
          style={{ width: "165px", fontSize: "0.75rem" }}
          name="order_id"
          placeholder="Order no."
          onKeyDown={(e) => handleKeyDown(e, onFilter)}
          value={filters.order_id}
          onChange={onChangeFilters}
        />
      </div>
      <div className="px-1">
        <div>
          <Label className="text-sm-label">Status</Label>
        </div>
        <Select
          placeholder="Status"
          dropdownMatchSelectWidth={false}
          style={{ width: "165px" }}
          value={filters.status}
          onChange={(value) =>
            onChangeFilters({ target: { name: "status", value } })
          }
        >
          <Option key="all" value={""}>
            All
          </Option>
          {[
            {
              label: "In progress",
              children: [
                {
                  label: "Unprepared",
                  value: "unprepared",
                },
                {
                  label: "Ready",
                  value: "ready",
                },
                {
                  label: "All in progress",
                  value: "active",
                },
              ],
            },
            {
              label: "Completed",
              children: [
                {
                  label: "Given away",
                  value: "given_away",
                },
              ],
            },
          ].map((d) => {
            return (
              <OptGroup key={`stat_${d.label}`} label={d.label}>
                {d.children?.map((d_children) => (
                  <Option
                    key={`stat_children_${d_children.value}`}
                    value={d_children.value}
                  >
                    {d_children.label}
                  </Option>
                ))}
              </OptGroup>
            );
          })}
          <Option key="pick_up" value={"pick_up"}>
            Pick up
          </Option>
          <Option key="change_mind" value={"change_mind"}>
            Change mind
          </Option>
          <Option key="canceled" value={"canceled"}>
            Canceled
          </Option>
        </Select>
      </div>
      {/* <div className="px-1">
        <SelectForm
          placeholder={"Status"}
          dropdownMatchSelectWidth={false}
          value={filters.status}
          onChange={(value) =>
            onChangeFilters({ target: { name: "status", value } })
          }
          options={[
            {
              label: "All",
              value: "",
            },
            {
              label: "In progress",
              value: "active",
            },
            {
              label: "Completed",
              value: "inactive",
            },
            {
              label: "Unprepared",
              value: "unprepared",
            },
            {
              label: "Ready",
              value: "ready",
            },
            {
              label: "Given away",
              value: "given_away",
            },
            {
              label: "Change mind",
              value: "change_mind",
            },
            {
              label: "Canceled",
              value: "canceled",
            },
          ]}
        />
      </div> */}

      <div className="px-1">
        <div className="form-group order-input-form-group">
          <Label className="text-sm-label">Date</Label>
          <div>
            <RangePickerComp
              placeholder={["Start time", "End time"]}
              value={[
                getDateFormat(filters.date[0]),
                getDateFormat(filters.date[1]),
              ]}
              onChange={(_, value) =>
                onChangeFilters({ target: { name: "date", value } })
              }
            />
          </div>
        </div>
      </div>

      <div className="px-1">
        <InputText
          style={{ width: 165, fontSize: "0.75rem" }}
          name="goods"
          placeholder="Goods"
          onKeyDown={(e) => handleKeyDown(e, onFilter)}
          value={filters.goods}
          onChange={onChangeFilters}
        />
      </div>

      <div className="px-1">
        <SelectForm
          placeholder={"Supplier"}
          style={{ width: 165 }}
          dropdownMatchSelectWidth={false}
          value={filters.supplier}
          onChange={(value) =>
            onChangeFilters({ target: { name: "supplier", value } })
          }
          options={
            pickup_address?.data
              ? [
                  {
                    label: "All",
                    value: null,
                  },
                  ...pickup_address?.data?.map((d) => ({
                    value: d.id,
                    label: d.code,
                  })),
                ]
              : []
          }
        />
      </div>
    </TableFilterBox>
  );
};
